import type { BenefitsConfig } from '#types/config/components/loyalty/benefits'
import type { RecursivePartial } from '#types/utils'

export default {
  showFreeShipping: true
} satisfies RecursivePartial<BenefitsConfig>
